<template>
  <el-tooltip placement="top" effect="light" :open-delay="300">
    <template #content>
      <div>
        <div v-for="tag in tags" :key="'tt' + tag.id" class="tag-dots__tooltip-row">
          <span class="tag-dots__dot tag-dots__dot--tooltip" :style="{ backgroundColor: tag.color }"></span>
          {{ tag.name }}
        </div>
      </div>
    </template>
    <span class="tag-dots" @click="$emit('click')">
      <span
        v-for="tag in visibleTags"
        :key="'td' + tag.id"
        class="tag-dots__dot"
        :style="{ backgroundColor: tag.color }"
      ></span>
      <span v-if="overflowCount > 0" class="tag-dots__overflow">+{{ overflowCount }}</span>
    </span>
  </el-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Tag {
  id: number;
  name: string;
  color: string;
}

const props = defineProps({
  tags: { type: Array as () => Tag[], required: true },
  max: { type: Number, default: 3 },
});

defineEmits(['click']);

const visibleTags = computed(() => props.tags.slice(0, props.max));
const overflowCount = computed(() => Math.max(0, props.tags.length - props.max));
</script>

<script lang="ts">
import { Tooltip } from 'element-ui';

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },
};
</script>

<style scoped lang="scss">
.tag-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  line-height: 1;

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
    border: 1px solid rgba(125, 125, 125, 0.35);

    &--tooltip {
      width: 8px;
      height: 8px;
      margin-right: 5px;
    }
  }

  &__overflow {
    font-size: 0.65rem;
    font-weight: 600;
    color: rgba(125, 125, 125, 0.9);
  }

  &__tooltip-row {
    display: flex;
    align-items: center;
    white-space: nowrap;

    + .tag-dots__tooltip-row {
      margin-top: 3px;
    }
  }
}
</style>
